import header from 'html/layouts/header.html';
import App from 'app/app.js';
import 'app/service/TranslateProviderService.js';
import 'app/store/JobStore.js';
import 'app/store/UserProfileStore.js';
import 'app/service/RouterService.js';
import 'app/store/ShoppingCartStore.js';
import 'app/store/ContentStore.js';
import 'app/service/BlockService.js';
function HeaderCtrl(
  $location,
  $uibModal,
  $rootScope,
  $scope,
  BlockService,
  JobStore,
  SubjectStore,
  RouterService,
  ShoppingCartStore,
  TranslateProviderService,
  UserProfileStore,
  ProductCatalogStore,
  $timeout,
  $filter,
  $route,
  ContentStore,
  OrderFormService,
  CommonService
) {
  var didPages = /^\/(downloads)|(didError)|(dsskError)|(safety)[\-\w+&@#\/%?=~|$!:,.;]*$/,
    pagesNotRequiringInfoBar = [/^\/getstarted$/, didPages];

  this.navState = '';
  this.mfrState = '';
  this.translateProviderService = TranslateProviderService;
  $scope.activePath = $location.path() || '';

  $scope.hideMFR = false;
  $rootScope.checkIfLoggedIn = false;
  $rootScope.globalBannerShow = true;
  this.showDropdown = false;
  this.routeLoadedCtrl = false;
  var that = this;

  $scope.$watch('checkIfLoggedIn', function (newValue, oldValue) {
    $rootScope.checkIfLoggedIn = UserProfileStore.isLoggedIn();
  });

  $scope.$on(
    '$routeChangeSuccess',
    function () {
      this.routeLoadedCtrl = true;
    }.bind(this)
  );

  this.firstName = function () {
    if (!!UserProfileStore.userProfile) {
      that.userProfile = R.clone(UserProfileStore.userProfile);
      return that.userProfile.firstName;
    }
  };

  this.toggleDropdown = function () {
    this.showDropdown = !this.showDropdown;
  };

  this.getLogoAlt = () => CommonService.getLogoAlt();

  document.addEventListener('click', function (event) {
    var dropdown = document.getElementById('login-status-icon');
    if (dropdown && !dropdown.contains(event.target)) {
      that.showDropdown = false;
      if (!$scope.$$phase) {
        $scope.$digest();
      }
    }
  });

  $scope.$on('$routeChangeSuccess', () => {
    this.routeLoadedCtrl = true;
    $scope.activePath = $location.path() || '';
  });

  this.showIdentityNavigation = function () {
    return RouterService.showIdentityNavigation();
  };

  this.menuHidden = function () {
    var isDontHaveCode = $location.path() === RouterService.paths.I_DONT_HAVE_CODE;
    var isNotLoggedIn = !(this.isJobLoaded() || UserProfileStore.isLoggedIn());

    return isNotLoggedIn || isDontHaveCode;
  };

  this.menuDisabled = function () {
    return !this.isJobLoaded() || this.isPayOnly() || this.isEnhancedPayOnly() || this.isMenuDisabledPage();
  };

  this.showFullMenu = function () {
    return !this.isJobLoaded() || this.isPayOnly() || this.isEnhancedPayOnly();
  };

  this.showPackages = function () {
    return this.showFullMenu() || ProductCatalogStore.containsPackage();
  };

  this.showCyop = function () {
    return this.isJobLoaded() && ProductCatalogStore.containsCyop();
  };

  this.showAddOns = function () {
    return this.showFullMenu() || (ProductCatalogStore.containsAddOn() && !ProductCatalogStore.isAddOnOnly());
  };

  this.showPhotos = function () {
    return this.isJobLoaded() && ProductCatalogStore.isAddOnOnly();
  };

  this.showBundles = function () {
    return this.showFullMenu() || ProductCatalogStore.containsBundle();
  };

  this.showMyDashboard = function () {
    return UserProfileStore.isLoggedIn();
  };

  this.showPortraitStore = function () {
    return !this.showMyDashboard();
  };

  this.isDashboard = function () {
    return $location.path() === RouterService.paths.DASHBOARD;
  };
  this.showProofs = function () {
    return this.isJobLoaded() && !JobStore.isReorderGroupOnly() && (JobStore.isReorder() || JobStore.isProofOrder());
  };
  this.navClick = function () {
    var state = this.navState === 'active';
    this.navState = !state ? 'active' : '';
  };

  this.mfrClick = function () {
    var state = this.mfrState === 'active';
    this.mfrState = !state ? 'active' : '';
  };

  this.closeMenuUnblock = function () {
    this.navState = '';
  };

  this.isLinkActive = function (page) {
    return $location.path() === RouterService.paths[page];
  };

  this.isInsideOfStudentIdAndPortIdFlow = function () {
    return (
      $location.path() === RouterService.paths.STUDENT_ID_INFO ||
      $location.path() === RouterService.paths.PREPAY_STUDENT_INFO ||
      $location.path() === RouterService.paths.FOUND_MATCH
    );
  };

  this.close = function () {
    $timeout(
      function () {
        this.navState = '';
      }.bind(this)
    );
  };

  $scope.isJobLoaded = this.isJobLoaded = function () {
    return JobStore.isJobLoaded();
  };

  $scope.isPayOnly = this.isPayOnly = function () {
    return JobStore.isPayOnly();
  };

  // MLC-1141 2016.10.13 MarkN - need to manage header links uniquely for Enhanced Pay Only
  this.isEnhancedPayOnly = function () {
    return JobStore.isEnhancedPayOnly();
  };

  this.logout = function () {
    const isIdentityLogin = UserProfileStore.isUserLoggedInWithIdentity();

    const performLogout = () =>
      UserProfileStore.logout()
        .then(() => {
          if (!isIdentityLogin) {
            $route.reload();
          }
        })
        .finally(() => {
          sessionStorage.removeItem('navHistory');
        });

    if ($location.path() === RouterService.paths.HOME) {
      this.closeMenuUnblock();
      performLogout();
    } else {
      this.goToHome();
      const unbinder = $rootScope.$on('$locationChangeSuccess', () => {
        performLogout().finally(unbinder); // ensure cleanup
      });
    }
    $rootScope.checkIfLoggedIn = UserProfileStore.isLoggedIn();
    this.showDropdown = false;
  };

  this.getCartTotal = function () {
    if ($location.path() === '/review-order') {
      return ShoppingCartStore.getTotal();
    }
    return ShoppingCartStore.getTotalWithoutTax();
  };

  this.getNumberOfItemsInCart = function () {
    return ShoppingCartStore.getNumberOfItemsInCartAndEnhancements();
  };

  this.displayName = function () {
    return ShoppingCartStore.getDisplayName();
  };

  this.goToHome = function () {
    this.closeMenuUnblock();
    OrderFormService.goToSignIn();
    RouterService.goToHome();
  };

  this.goToHomePage = function () {
    if (this.menuDisabled()) {
      return;
    }
    this.goToHome();
  };

  this.goToPackages = function () {
    if (this.menuDisabled()) {
      return;
    }
    this.closeMenuUnblock();
    RouterService.goToPackages();
  };
  this.goToMyProofs = function () {
    if (this.menuDisabled()) {
      return;
    }
    this.closeMenuUnblock();
    RouterService.goToMyProofs();
  };
  this.goToLogin = function () {
    this.closeMenuUnblock();
    RouterService.goToLogin();
    this.showDropdown = false;
  };

  this.goToAddOn = function () {
    if (this.menuDisabled()) {
      return;
    }
    this.closeMenuUnblock();
    RouterService.goToAddOn();
  };

  this.goToShoppingCart = function () {
    this.closeMenuUnblock();
    RouterService.goToShoppingCart();
  };

  this.goToCyop = function () {
    if (this.menuDisabled()) {
      return;
    }
    this.closeMenuUnblock();
    RouterService.goToCYOP();
  };

  this.goToMyAccount = function ($event) {
    $event.preventDefault();
    this.closeMenuUnblock();
    RouterService.goToMyAccount();
    this.showDropdown = false;
  };

  this.goToExplainer = function () {
    this.closeMenuUnblock();
    RouterService.goToExplainer();
  };

  this.goToSpecialOffers = function () {
    if (this.menuDisabled()) {
      return;
    }
    this.closeMenuUnblock();
    RouterService.goToSpecialOffers();
  };

  this.goToMyDashboard = function () {
    this.closeMenuUnblock();
    RouterService.goToMyDashboard();
  };

  this.onLogoClick = function () {
    this.closeMenuUnblock();

    const loggedIn = UserProfileStore.isLoggedIn();
    const currentPath = $location.path();
    if (loggedIn && currentPath === '/my-dashboard') {
      return;
    }
    if (loggedIn) {
      RouterService.goToMyDashboard();
      return;
    }
    if (currentPath !== '/') {
      this.goToHome();
    }
  };

  this.isInfoBarNotRequired = function () {
    return R.any(function (page) {
      return R.test(page, $location.path());
    })(pagesNotRequiringInfoBar);
  };

  this.shiftInfoBar = function () {
    return JobStore.isJobLoaded() || R.test(didPages, $location.path());
  };

  this.goToCreateAccount = function ($event) {
    if ($event) {
      $event.preventDefault();
    }
    this.closeMenuUnblock();
    RouterService.goToLogin();
    this.showDropdown = false;
  };

  this.isPayOnlyPage = function () {
    return $location.path() === RouterService.paths.PAY_ONLY;
  };

  this.isMenuDisabledPage = function () {
    return (
      $location.path() === RouterService.paths.STUDENT_ID_INFO ||
      $location.path() === RouterService.paths.PICTURE_DAY ||
      $location.path() === RouterService.paths.FOUND_MATCH ||
      $location.path() === RouterService.paths.FIND_SCHOOL ||
      $location.path() === RouterService.paths.EVENT_LIST ||
      $location.path() === RouterService.paths.PREPAY_STUDENT_INFO
    );
  };

  this.testingUserText = function () {
    var content = '';
    if (UserProfileStore.isTestingUser()) {
      content = ContentStore.getContent('MOBILE_TRANS_HOME', 'TESTING_MODE');
    }
    return content;
  };

  this.showGlobalBanner = function () {
    var globalBanner = ContentStore.getContent('MESSAGE_CENTER', 'GLOBAL_BANNER_MESSAGE_DESKTOP');
    return (
      $rootScope.globalBannerShow && globalBanner !== undefined && globalBanner !== null && globalBanner.trim() !== ''
    );
  };

  this.globalBannerTheme = function () {
    var theme = ContentStore.getContent('MESSAGE_CENTER', 'GLOBAL_BANNER_MESSAGE_THEME');
    if (theme !== undefined && theme !== null && theme.trim() !== '') {
      return theme;
    } else {
      return '';
    }
  };

  this.closeGlobalBanner = function () {
    $rootScope.globalBannerShow = false;
  };

  $scope.$on('$routeChangeSuccess', this.close.bind(this));
}

App.component('ltHeader', {
  template: header,
  controller: [
    '$location',
    '$uibModal',
    '$rootScope',
    '$scope',
    'BlockService',
    'JobStore',
    'SubjectStore',
    'RouterService',
    'ShoppingCartStore',
    'TranslateProviderService',
    'UserProfileStore',
    'ProductCatalogStore',
    '$timeout',
    '$filter',
    '$route',
    'ContentStore',
    'OrderFormService',
    'CommonService',
    HeaderCtrl
  ],
  controllerAs: 'header'
});
